import { useParams } from "react-router-dom";
import { checkAuth, createApply, getQs } from "../utils/api";
import { useEffect, useState } from "react";

export default function Apply() {
  let { id } = useParams() as { id: string };
  let [q, setqs] = useState([]);
  let [inputvalues, setinputvalues] = useState<any>({});
  useEffect(() => {
    checkAuth();
    getQs(id)
      .then(({ data }) => {
        if(!data) return window.location.href = `/`
        setqs(data);
      })
      .catch(() => (window.location.href = "/"));
  }, [id]);
  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          createApply(id, inputvalues);
        }}
      >
        {q?.filter(f=>f!== null || f !== undefined || f !== "")?.map((Q) => {
          return (
            <>
              <input
                id={"input-" + Q}
                onChange={(ee: any) => {
                  setinputvalues({ ...inputvalues, [Q]: ee.target.value });
                }}
                placeholder={Q}
                required
              />
            </>
          );
        })}
        <input type="submit" value="submit" />
      </form>
    </>
  );
}
